import { FC } from "react";

import { Badge } from "@hightouchio/ui";

type Props = { text?: string };

export const DraftBadge: FC<Props> = ({ text = "Draft" }) => <Badge>{text}</Badge>;
